var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3875 54.4204C22.4845 55.0522 23.7289 55.3848 24.9956 55.3848C26.2624 55.3848 27.5068 55.0522 28.6038 54.4204L46.3919 44.1795C47.4888 43.5478 48.3997 42.6392 49.0331 41.5451C49.6664 40.451 49.9999 39.2098 50 37.9464L50 17.4386C49.9999 16.1751 49.6664 14.934 49.0331 13.8398C48.3997 12.7457 47.4888 11.8371 46.3919 11.2054L28.6038 0.964536C27.5068 0.332765 26.2624 0.000161736 24.9956 0.000161847C23.7289 0.000161958 22.4845 0.332766 21.3875 0.964537L3.60817 11.2054C2.51124 11.8371 1.60032 12.7457 0.966963 13.8398C0.333604 14.934 0.000102179 16.1751 -3.31736e-06 17.4386L-1.52451e-06 37.9464C0.000104193 39.2098 0.333606 40.451 0.966965 41.5451C1.60032 42.6392 2.51124 43.5478 3.60817 44.1795L21.3875 54.4204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6 20.8004H25L23.308 19.1084C22.852 18.6524 22.24 18.4004 21.604 18.4004H15.4C14.08 18.4004 13.012 19.4804 13.012 20.8004L13 35.2004C13 36.5204 14.08 37.6004 15.4 37.6004H34.6C35.92 37.6004 37 36.5204 37 35.2004V23.2004C37 21.8804 35.92 20.8004 34.6 20.8004ZM26.2 29.2004V32.8004C26.2 33.4604 25.66 34.0004 25 34.0004C24.34 34.0004 23.8 33.4604 23.8 32.8004V29.2004H21.652C21.112 29.2004 20.848 28.5524 21.232 28.1804L24.592 24.8324C24.832 24.5924 25.204 24.6044 25.444 24.8324L28.792 28.1804C29.152 28.5524 28.888 29.2004 28.36 29.2004H26.2Z",
    fill: "#9779FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvHexagon);
export default __webpack_public_path__ + "static/media/csv_hexagon.cfa1ffe09dd8af8dc3135b8d84c14b9b.svg";
export { ForwardRef as ReactComponent };